export const DATE_OPTIONS = [
    {
        name: 'Exact dates',
        value: 'exact_dates'
    },
    {
        name: '± 1 day',
        value: 'one_day'
    },
    {
        name: '± 2 days',
        value: 'two_days'
    },
    {
        name: '± 3 days',
        value: 'three_day'
    }
];

export const TRAVELERS_NUMBERS = [
    {
        label: '1 traveler',
        value: '1 traveler'
    },
    {
        label: '2 travelers',
        value: '2 travelers'
    },
    {
        label: '3 travelers',
        value: '3 travelers'
    },
    {
        label: '4 travelers',
        value: '4 travelers'
    },
    {
        label: '5 travelers',
        value: '5 travelers'
    },
    {
        label: '6 travelers',
        value: '6 travelers'
    },
    {
        label: '7 travelers',
        value: '7 travelers'
    },
    {
        label: '8 travelers',
        value: '8 travelers'
    }
];

export const AIRPLANE_CLASSES = [
    {
        label: 'Economy',
        value: 'Economy'
    },
    {
        label: 'Premium Economy',
        value: 'Premium Economy'
    },
    {
        label: 'Business',
        value: 'Business'
    },
    {
        label: 'First',
        value: 'First'
    },
    {
        label: 'Any',
        value: 'Any'
    }
];
export const MONTH_ABBREVIATION = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN",
  "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
];
export const MONTHS = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];
export const DAY_ABBREVIATION = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
export const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
